import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { cn } from '@/lib/utils'
import { media } from '@/constants/media'
import { Magnetic } from '@/components/generals/magnetic'

interface ContactPillProps {
    className?: string
    label?: string
}

/* The accent button that closes every layout: a portrait, then an arrow that
   kicks to 45 degrees on hover. */
export const ContactPill: FC<ContactPillProps> = ({ className, label = 'Contact Noma Studio' }): ReactNode => {
    return (
        <Magnetic strength={0.22} className={className}>
            <Link
                href='/contact'
                aria-label={label}
                data-cursor='link'
                className='group/pill flex w-fit items-center gap-2 rounded-[var(--radius-chip)] bg-brand p-1.5'
            >
                <img
                    src={media.people.contactPill}
                    alt=''
                    loading='lazy'
                    className='size-8 rounded-[var(--radius-chip)] object-cover'
                />

                <span
                    data-magnetic-inner
                    className='flex size-8 items-center justify-center text-paper transition-transform duration-500 group-hover/pill:rotate-45'
                >
                    <svg viewBox='0 0 24 24' className='size-4' fill='none' aria-hidden='true'>
                        <path d='M5 19L19 5M19 5H8M19 5v11' stroke='currentColor' strokeWidth='2' />
                    </svg>
                </span>
            </Link>
        </Magnetic>
    )
}
